// extracted by mini-css-extract-plugin
export default {"switchContainer":"languageSwitcher_switchContainer__hNeHu"};